import { capitalizeFirstLetter } from "app/main/utils/tableUtils";

const relaySchedules = {
	urlGET: "api/profile/carriers/:carrierId/relay-schedules",
	idKey: "_id",
	listenEvent: ["relayScheduleRevision", "profileRevision"],
	segmentKey: "CARRIER_RELAY_SCHEDULES",
	content: {
		table: {
			variant: "skinny",
			layout: [
				"schedule_name",
				"schedule_type",
				"origin",
				"destination",
				"time_window",
				"assigned_trucks",
				"max_concurrent_loads",
				"status",
			],
		},
		pagination: {
			enabled: true,
			resetScroll: true,
		},
		defaults: {
			initial: {
				filters: {
					status: "ACTIVE",
				},
			},
			items: [
				{
					label: "Active",
					description: "Active Schedules",
					filters: {
						status: "ACTIVE",
					},
				},
				{
					label: "Inactive",
					description: "Inactive Schedules",
					filters: {
						status: "INACTIVE",
					},
				},
			],
		},
		filters: {
			search: true,
			countVisible: 0,
			items: [
				{
					key: "status",
					type: "select",
					label: "Status",
					defaultValue: "__NOT_SELECTED__",
					options: [
						{
							value: "__NOT_SELECTED__",
							label: "Not Selected",
						},
						{
							label: "Active",
							value: "ACTIVE",
						},
						{
							label: "Inactive",
							value: "INACTIVE",
						},
					],
				},
				{
					key: "schedule_type",
					type: "select",
					label: "Schedule Type",
					defaultValue: "__NOT_SELECTED__",
					options: [
						{
							value: "__NOT_SELECTED__",
							label: "Not Selected",
						},
						{
							label: "Pickup",
							value: "PICKUP",
						},
						{
							label: "Delivery",
							value: "DELIVERY",
						},
						{
							label: "Long Haul",
							value: "LONGHAUL",
						},
					],
				},
			],
		},
		items: [
			{
				key: "schedule_name",
				type: "text",
				label: "Schedule Name",
				table: { width: "20%" },
			},
			{
				key: "schedule_type",
				type: "text",
				label: "Type",
				table: { width: "12%" },
				builder: (item) => capitalizeFirstLetter(item.schedule_type?.toLowerCase() || ""),
			},
			{
				key: "origin",
				type: "text",
				label: "Origin",
				table: { width: "18%" },
				builder: (item) => {
					if (item.origin_type === "YARD" && item.origin_yard) {
						return item.origin_yard.name || "Yard";
					} else if (item.origin_type === "FLEXIBLE") {
						return "Flexible";
					}
					return "Not Set";
				},
			},
			{
				key: "destination",
				type: "text",
				label: "Destination",
				table: { width: "18%" },
				builder: (item) => {
					if (item.destination_type === "YARD" && item.destination_yard) {
						return item.destination_yard.name || "Yard";
					} else if (item.destination_type === "FLEXIBLE") {
						return "Flexible";
					}
					return "Not Set";
				},
			},
			{
				key: "time_window",
				type: "text",
				label: "Time Window",
				table: { width: "15%" },
				builder: (item) => {
					if (item.start_time && item.end_time) {
						const daysCount = item.days_of_week?.length || 0;
						return `${item.start_time}-${item.end_time} (${daysCount} days)`;
					}
					return "Not Set";
				},
			},
			{
				key: "assigned_trucks",
				type: "text",
				label: "Trucks",
				table: { width: "8%" },
				builder: (item) => {
					const count = item.assigned_trucks?.length || 0;
					return count > 0 ? `${count}` : "0";
				},
			},
			{
				key: "max_concurrent_loads",
				type: "text",
				label: "Max Loads",
				table: { width: "8%" },
				builder: (item) => item.max_concurrent_loads ?? 1,
			},
			{
				key: "status",
				type: "text",
				label: "Status",
				table: { width: "7%" },
				builder: (item) => capitalizeFirstLetter(item.status?.toLowerCase() || ""),
			},
			{
				key: "menu",
				type: "menu",
				label: "Menu",
				items: [
					{
						key: "edit",
						label: "Edit",
						auth: ["carrier", "carrier_manager", "carrier_dispatcher", "administrator"],
						dialogBuilder: (item, dataIds) => ({
							viewId: "RELAY_SCHEDULE_VIEW",
							mode: "EDIT",
							dataIds: { ...dataIds, id: item._id, relayScheduleId: item._id, mode: "EDIT" },
						}),
					},
					{
						key: "divider",
						variant: "divider",
						auth: ["carrier", "carrier_manager", "carrier_dispatcher", "administrator"],
					},
					{
						key: "activate",
						label: "Activate",
						auth: ["carrier", "carrier_manager", "carrier_dispatcher", "administrator"],
						dialogBuilder: (item, dataIds) => ({
							formId: "RELAY_SCHEDULE_STATUS_FORM",
							mode: "DELETE",
							dataIds: { ...dataIds, id: item._id, status: "ACTIVE" },
						}),
						isVisible: (item) => item.status !== "ACTIVE",
					},
					{
						key: "inactivate",
						label: "Deactivate",
						auth: ["carrier", "carrier_manager", "carrier_dispatcher", "administrator"],
						dialogBuilder: (item, dataIds) => ({
							formId: "RELAY_SCHEDULE_STATUS_FORM",
							mode: "DELETE",
							dataIds: { ...dataIds, id: item._id, status: "INACTIVE", item: item },
						}),
						isVisible: (item) => item.status === "ACTIVE",
					},
				],
			},
		],
	},
};

export default relaySchedules;
